import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { SessionKey_Permissions_FE } from '@nu-art/permissions-frontend/index';
import { DefaultAccessLevel_NoAccess, defaultAccessLevels } from '@nu-art/permissions-shared';
import { ModuleFE_Organization } from '@app/org-frontend';
import { LL_V_L, TS_PropRenderer } from '@nu-art/thunderstorm-frontend/index';
import './renderers.scss';
import { SessionKeyFE_Account } from '@nu-art/user-account-frontend';
export const Renderer_OrgPermissionNamesElaborate = () => {
    const roles = SessionKey_Permissions_FE.get().roles;
    const organizations = ModuleFE_Organization.cache.all();
    const _descriptors = organizations.map(org => {
        return {
            org: org,
            permissionValue: SessionKey_Permissions_FE.get().domainToValueMap[org._id], // permission domains of organizations are equal to their _id.
        };
    });
    return _jsxs(LL_V_L, { className: 'container_role-names', children: [_jsx(TS_PropRenderer.Vertical, { label: _jsx("div", { className: 'organizations-container-label', children: "Organizations:" }), children: _descriptors.map(descriptor => {
                    const valueLabel = defaultAccessLevels.find(defAL => defAL.value === descriptor.permissionValue)?.name;
                    if (valueLabel === DefaultAccessLevel_NoAccess.name)
                        return; // Don't show organizations the user needs not and cares not about.
                    const orgLabel = descriptor.org.alias ?? descriptor.org.name;
                    return _jsx(TS_PropRenderer.Vertical, { label: orgLabel, id: descriptor.org._id, children: _jsx("div", { className: 'role-name', children: valueLabel }) });
                }) }), _jsx("span", { className: 'separator' }), _jsx(TS_PropRenderer.Vertical, { label: 'Roles', children: roles.map(roleName => _jsx("div", { className: 'role-name', id: roleName.key, children: roleName.uiLabel })) })] });
};
export const Renderer_OrgPermissionNames = () => {
    const roles = SessionKey_Permissions_FE.get().roles;
    const userOrganization = ModuleFE_Organization.getOrganizationByEmail(SessionKeyFE_Account.get().email);
    if (!userOrganization)
        return _jsx(_Fragment, { children: `user email doesn\'t match\nany existing organization` });
    //User must have an organization
    const userOrganizationRole = roles.find(role => role.key.includes(userOrganization.alias));
    if (!userOrganizationRole)
        return _jsx(_Fragment, { children: `no role name matches organization\nupdate role names` });
    //The organization's role name must be updated consistently to contain the organization's alias.
    //If it doesn't have the organization's alias, it needs to be updated to contain in.
    //Organization roles are created automatically with an organization's alias.
    const userOrganizationRoleToRender = userOrganizationRole.uiLabel;
    //--------------------------------------------------------
    // const organizations = ModuleFE_Organization.cache.all();
    // const _descriptors = organizations.map(org => {
    // 	return {
    // 		org: org,
    // 		permissionValue: SessionKey_Permissions_FE.get().domainToValueMap[org._id], // permission domains of organizations are equal to their _id.
    // 	};
    // });
    return _jsx(LL_V_L, { className: 'container_role-names', children: _jsx(TS_PropRenderer.Vertical, { label: `${userOrganization.alias} organization`, children: _jsx("div", { className: 'role-name', children: userOrganizationRoleToRender }) }) });
};
//# sourceMappingURL=renderers.js.map